/* NYUM PREMIUM CONVERSION INTERACTIONS — draft-only shell hardening */
(function () {
  'use strict';

  var body = document.body;
  if (!body || !body.classList.contains('nyum-body')) return;
  document.documentElement.classList.add('nyum-premium-ui');

  function setPanel(group, open) {
    if (!group) return;
    var panel = group.querySelector('.nyum-nav-panel');
    if (!panel) return;
    var trigger = Array.prototype.find.call(group.children, function (child) { return child.tagName === 'BUTTON'; });
    group.toggleAttribute('data-nyum-hover-open', open);
    if (!open) group.removeAttribute('data-nyum-click-open');
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', String(open));
    }
    panel.style.setProperty('opacity', open ? '1' : '0', 'important');
    panel.style.setProperty('visibility', open ? 'visible' : 'hidden', 'important');
    panel.style.setProperty('pointer-events', open ? 'auto' : 'none', 'important');
    var centeredPanel = panel.classList.contains('nyum-v8-panel');
    panel.style.setProperty('transform', centeredPanel ? (open ? 'translate(-50%, 0)' : 'translate(-50%, 8px)') : (open ? 'translateY(0)' : 'translateY(8px)'), 'important');
  }

  function closePanels(except) {
    document.querySelectorAll('.nyum-desktop-nav .nyum-nav-group').forEach(function (group) {
      if (group !== except) setPanel(group, false);
    });
  }

  document.querySelectorAll('.nyum-desktop-nav .nyum-nav-group').forEach(function (group) {
    var trigger = Array.prototype.find.call(group.children, function (child) { return child.tagName === 'BUTTON'; });
    if (trigger) {
      trigger.setAttribute('aria-haspopup', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }
  });

  function setCart(open) {
    var layer = document.querySelector('[data-nyum-cart-layer]');
    if (!layer) return;
    layer.classList.toggle('is-open', open);
    layer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-nyum-cart-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
    });
    body.style.overflow = open ? 'hidden' : '';
  }

  document.addEventListener('click', function (event) {
    var navTrigger = event.target.closest && event.target.closest('.nyum-desktop-nav .nyum-nav-group > button');
    if (navTrigger) {
      var group = navTrigger.closest('.nyum-nav-group');
      var clickLocked = group.hasAttribute('data-nyum-click-open');
      var opening = !clickLocked;
      closePanels(group);
      group.toggleAttribute('data-nyum-click-open', opening);
      setPanel(group, opening);
      return;
    }

    var cartOpen = event.target.closest && event.target.closest('[data-nyum-cart-open]');
    if (cartOpen) {
      /* Open immediately; the main cart controller refreshes contents afterward. */
      setCart(true);
      return;
    }

    var cartClose = event.target.closest && event.target.closest('[data-nyum-cart-close]');
    if (cartClose) {
      setCart(false);
      return;
    }

    if (!event.target.closest('.nyum-desktop-nav')) closePanels();
    var mobileMenu = document.querySelector('[data-nyum-mobile-menu]');
    var menuButton = document.querySelector('[data-nyum-menu-toggle]');
    if (mobileMenu && mobileMenu.classList.contains('is-open') && !event.target.closest('[data-nyum-mobile-menu], [data-nyum-menu-toggle]')) {
      mobileMenu.classList.remove('is-open');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closePanels();
    setCart(false);
    var mobileMenu = document.querySelector('[data-nyum-mobile-menu]');
    var menuButton = document.querySelector('[data-nyum-menu-toggle]');
    var wasMobileMenuOpen = !!(mobileMenu && mobileMenu.classList.contains('is-open'));
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    if (menuButton) {
      menuButton.setAttribute('aria-expanded', 'false');
      if (wasMobileMenuOpen) menuButton.focus();
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth <= 1050) closePanels();
  }, { passive: true });
}());

/* NYUM navigation rebuild — one shared, low-latency interaction model for every dropdown. */
(function () {
  'use strict';

  var root = document.querySelector('[data-nyum-nav-rebuild]');
  if (!root) return;

  var groups = Array.prototype.slice.call(root.querySelectorAll('[data-nyum-rebuild-group]'));
  var closeTimer = 0;
  var activeGroup = null;

  function clearCloseTimer() {
    if (!closeTimer) return;
    window.clearTimeout(closeTimer);
    closeTimer = 0;
  }

  function setGroup(group, open, locked) {
    if (!group) return;
    var trigger = group.querySelector(':scope > button');
    var panel = group.querySelector('[data-nyum-rebuild-panel]');
    if (!trigger || !panel) return;

    if (locked) group.setAttribute('data-nyum-rebuild-locked', '');
    if (!open) group.removeAttribute('data-nyum-rebuild-locked');

    var alreadyOpen = group.classList.contains('is-open') && panel.classList.contains('is-open');
    group.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', String(open));
    if (!alreadyOpen || !open) panel.classList.toggle('is-open', open);
  }

  function closeAll(except) {
    clearCloseTimer();
    groups.forEach(function (group) {
      if (group === except) return;
      if (group.classList.contains('is-open') || group.hasAttribute('data-nyum-rebuild-locked')) {
        setGroup(group, false, false);
      }
    });
    if (!except) activeGroup = null;
  }

  function openGroup(group, locked) {
    clearCloseTimer();
    if (activeGroup === group && group.classList.contains('is-open')) {
      if (locked) group.setAttribute('data-nyum-rebuild-locked', '');
      return;
    }
    closeAll(group);
    activeGroup = group;
    setGroup(group, true, locked);
  }

  function scheduleClose(group) {
    clearCloseTimer();
    if (group.hasAttribute('data-nyum-rebuild-locked')) return;
    closeTimer = window.setTimeout(function () {
      closeTimer = 0;
      if (group.matches(':hover') || group.matches(':focus-within')) return;
      setGroup(group, false, false);
      if (activeGroup === group) activeGroup = null;
    }, 120);
  }

  groups.forEach(function (group) {
    var trigger = group.querySelector(':scope > button');
    if (!trigger) return;

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var open = group.classList.contains('is-open');
      if (open && group.hasAttribute('data-nyum-rebuild-locked')) {
        setGroup(group, false, false);
        if (activeGroup === group) activeGroup = null;
      } else {
        openGroup(group, true);
      }
    });

    group.addEventListener('pointerenter', function () {
      if (window.matchMedia('(min-width: 981px)').matches && !group.hasAttribute('data-nyum-rebuild-locked')) {
        openGroup(group, false);
      }
    }, { passive: true });

    group.addEventListener('pointerleave', function () {
      scheduleClose(group);
    }, { passive: true });

    group.addEventListener('focusin', function () {
      openGroup(group, false);
    });

    group.addEventListener('focusout', function (event) {
      if (!group.contains(event.relatedTarget)) scheduleClose(group);
    });
  });

  function warmMenuMedia() {
    Array.prototype.forEach.call(root.querySelectorAll('[data-nyum-rebuild-panel] img'), function (img) {
      img.loading = 'eager';
      img.fetchPriority = 'high';
      img.decoding = 'async';
      if (typeof img.decode === 'function') img.decode().catch(function () {});
    });
  }

  /* Start warming immediately so the first hover never reveals an unfinished panel. */
  warmMenuMedia();

  var mobileMenu = root.querySelector('[data-nyum-mobile-menu]');
  var mobileToggle = root.querySelector('[data-nyum-menu-toggle]');

  function setMobile(open) {
    if (!mobileMenu || !mobileToggle) return;
    mobileMenu.classList.toggle('is-open', open);
    mobileToggle.setAttribute('aria-expanded', String(open));
    mobileToggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  if (mobileToggle) {
    mobileToggle.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      setMobile(!mobileMenu.classList.contains('is-open'));
    });
  }

  if (mobileMenu) {
    mobileMenu.addEventListener('click', function (event) {
      if (event.target.closest('a')) setMobile(false);
    });
  }

  function setRebuildCart(open) {
    var layer = document.querySelector('[data-nyum-cart-layer]');
    if (!layer) return;
    layer.classList.toggle('is-open', open);
    layer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.querySelectorAll('[data-nyum-cart-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
    });
    document.body.style.overflow = open ? 'hidden' : '';
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-nyum-cart-open]')) {
      setRebuildCart(true);
      return;
    }
    if (event.target.closest('[data-nyum-cart-close]')) {
      setRebuildCart(false);
      return;
    }
    if (!event.target.closest('[data-nyum-nav-rebuild]')) {
      closeAll();
      setMobile(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeAll();
    setMobile(false);
    setRebuildCart(false);
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth <= 980) closeAll();
  }, { passive: true });
}());


/* NYUM STANDARD — interactive proof trail */
(function () {
  'use strict';

  function initNyumStandardTrail() {
    var root = document.querySelector('.nyum-page--the-nyum-standard .nyum-standard-action');
    if (!root || root.getAttribute('data-nyum-standard-ready') === 'true') return;

    var trail = root.querySelector('.nyum-standard-action__trail');
    if (!trail) return;

    var items = Array.prototype.slice.call(trail.querySelectorAll(':scope > li'));
    if (items.length !== 9) return;

    var details = [
      { label: 'SOURCE', value: 'NORTH ATLANTIC', text: 'The marine source is named clearly instead of disappearing behind a generic extract label.' },
      { label: 'SPECIES', value: 'UNDARIA + FUCUS', text: 'The named species are visible in the formula record, so the source story can be understood before checkout.' },
      { label: 'FORM', value: 'CONCENTRATED EXTRACT', text: 'The ingredient form is stated plainly rather than leaving the shopper to guess what “extract” means.' },
      { label: 'EXTRACTION', value: 'WATER PATHWAY', text: 'The extraction pathway is part of the disclosed formula record—not an invisible manufacturing detail.' },
      { label: 'LABEL AMOUNT', value: '300 MG / CAPSULE', text: 'This is the complete Super-U-100® marine extract amount declared per capsule.' },
      { label: 'STANDARDIZATION', value: '75% · HPLC', text: 'The fucoidan standardization and the analytical method are shown together.' },
      { label: 'COMPANION ACTIVE', value: '+ 250 MG REISHI', text: 'The companion Reishi amount is quantified instead of being buried inside an unnamed blend.' },
      { label: 'FORMAT', value: '60 CAPSULES', text: 'The actual bottle format is visible as part of the buying decision.' },
      { label: 'DISCLOSE', value: 'FULL CURRENT LABEL', text: 'Supplement Facts, serving size, other ingredients, and warnings belong next to the claim.' }
    ];

    var readout = document.createElement('div');
    readout.className = 'nyum-standard-action__readout';
    readout.innerHTML = '<div class="nyum-standard-action__readout-meta"><small data-nyum-standard-readout-index></small><b data-nyum-standard-readout-label></b></div><div class="nyum-standard-action__readout-copy"><strong data-nyum-standard-readout-value></strong><p data-nyum-standard-readout-text></p></div><button class="nyum-standard-action__readout-next" type="button" data-nyum-standard-next>NEXT PROOF →</button>';
    trail.insertAdjacentElement('afterend', readout);

    var indexNode = readout.querySelector('[data-nyum-standard-readout-index]');
    var labelNode = readout.querySelector('[data-nyum-standard-readout-label]');
    var valueNode = readout.querySelector('[data-nyum-standard-readout-value]');
    var textNode = readout.querySelector('[data-nyum-standard-readout-text]');
    var nextButton = readout.querySelector('[data-nyum-standard-next]');
    var activeIndex = 4;

    function setActive(index, moveFocus) {
      activeIndex = (index + items.length) % items.length;
      var detail = details[activeIndex];
      items.forEach(function (item, itemIndex) {
        var active = itemIndex === activeIndex;
        item.classList.toggle('is-result', active);
        item.setAttribute('aria-pressed', String(active));
        item.setAttribute('tabindex', active ? '0' : '-1');
        if (active && moveFocus) item.focus({ preventScroll: true });
      });
      indexNode.textContent = 'PROOF ' + String(activeIndex + 1).padStart(2, '0') + ' / 09';
      labelNode.textContent = detail.label;
      valueNode.textContent = detail.value;
      textNode.textContent = detail.text;
      root.setAttribute('data-nyum-standard-active', String(activeIndex + 1));
    }

    items.forEach(function (item, itemIndex) {
      item.setAttribute('role', 'button');
      item.setAttribute('aria-pressed', 'false');
      item.setAttribute('tabindex', '-1');
      item.setAttribute('data-nyum-standard-step', String(itemIndex + 1));
      item.setAttribute('aria-label', details[itemIndex].label + ': ' + details[itemIndex].value);

      item.addEventListener('click', function () {
        setActive(itemIndex, false);
      });

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) setActive(itemIndex, false);
      }, { passive: true });

      item.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          setActive(itemIndex, false);
        } else if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          setActive(itemIndex + 1, true);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          setActive(itemIndex - 1, true);
        }
      });
    });

    nextButton.addEventListener('click', function () {
      setActive(activeIndex + 1, false);
    });

    setActive(activeIndex, false);
    root.setAttribute('data-nyum-standard-ready', 'true');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-visible');
            observer.disconnect();
          }
        });
      }, { threshold: 0.12 });
      observer.observe(root);
    } else {
      root.classList.add('is-visible');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNyumStandardTrail, { once: true });
  } else {
    initNyumStandardTrail();
  }
  document.addEventListener('shopify:section:load', initNyumStandardTrail);
}());


/* NYUM STANDARD — proof-point icon system */
(function () {
  'use strict';

  function initNyumStandardIcons() {
    var root = document.querySelector('.nyum-page--the-nyum-standard .nyum-standard-action');
    if (!root) return;
    var trail = root.querySelector('.nyum-standard-action__trail');
    if (!trail) return;
    var items = Array.prototype.slice.call(trail.querySelectorAll(':scope > li'));
    if (items.length !== 9) return;

    var marks = [
      '<path d="M3 17c4.5 0 4.8-7 9-7s4.5 7 9 4"></path><path d="M5 7c1.5 2 3.3 3 5.5 3"></path>',
      '<path d="M6 20c0-7 3-12 9-16 1 7-2 12-9 16Z"></path><path d="M6 20c3-3 6-6 9-10"></path><path d="M13 20c1-4 3-6 6-8"></path>',
      '<path d="M12 3S6 10 6 14a6 6 0 0 0 12 0c0-4-6-11-6-11Z"></path>',
      '<path d="M9 3h6M10 3v6l-5 8a3 3 0 0 0 2.6 4h8.8A3 3 0 0 0 19 17l-5-8V3"></path><path d="M8 15h8"></path>',
      '<rect x="7" y="4" width="10" height="16" rx="5"></rect><path d="M7 12h10"></path>',
      '<circle cx="12" cy="12" r="8"></circle><path d="M12 4v16M4 12h16"></path><path d="m8 15 2-2 2 1 4-5"></path>',
      '<path d="M4 12c0-5 3.5-8 8-8s8 3 8 8H4Z"></path><path d="M12 12v8M8 20h8"></path>',
      '<path d="M8 5h8l2 2v12H6V5h2Z"></path><path d="M9 5V3h6v2M9 10h6M9 14h6M9 17h4"></path>',
      '<path d="M6 3h9l3 3v15H6z"></path><path d="M15 3v4h4M9 12h6M9 16h3"></path><path d="m14 16 1.5 1.5L19 14"></path>'
    ];

    function svg(mark) {
      return '<svg viewBox="0 0 24 24" aria-hidden="true">' + mark + '</svg>';
    }

    items.forEach(function (item, index) {
      if (!item.querySelector('.nyum-standard-action__step-icon')) {
        var icon = document.createElement('span');
        icon.className = 'nyum-standard-action__step-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.innerHTML = svg(marks[index]);
        var anchor = item.children[1] || null;
        item.insertBefore(icon, anchor);
      }
    });

    var readoutMeta = root.querySelector('.nyum-standard-action__readout-meta');
    if (!readoutMeta) return;
    var readoutIcon = readoutMeta.querySelector('.nyum-standard-action__readout-icon');
    if (!readoutIcon) {
      readoutIcon = document.createElement('span');
      readoutIcon.className = 'nyum-standard-action__readout-icon';
      readoutIcon.setAttribute('aria-hidden', 'true');
      readoutMeta.insertBefore(readoutIcon, readoutMeta.firstChild);
    }

    function syncReadoutIcon() {
      var active = Number(root.getAttribute('data-nyum-standard-active') || 5) - 1;
      active = Math.max(0, Math.min(8, active));
      readoutIcon.innerHTML = svg(marks[active]);
    }

    syncReadoutIcon();
    if (window.MutationObserver) {
      var observer = new MutationObserver(syncReadoutIcon);
      observer.observe(root, { attributes: true, attributeFilter: ['data-nyum-standard-active'] });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNyumStandardIcons, { once: true });
  } else {
    initNyumStandardIcons();
  }
  document.addEventListener('shopify:section:load', initNyumStandardIcons);
}());


/* NYUM STANDARD — verified checkmark badges */
(function () {
  'use strict';

  var mark = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 12.5 10.5 17 18 8.5"></path></svg>';

  function initNyumStandardChecks() {
    var root = document.querySelector('.nyum-page--the-nyum-standard .nyum-standard-action');
    if (!root) return;
    root.querySelectorAll('.nyum-standard-action__step-icon, .nyum-standard-action__readout-icon').forEach(function (node) {
      node.innerHTML = mark;
    });
    root.setAttribute('data-nyum-standard-checkmarks', 'true');
  }

  function boot() {
    initNyumStandardChecks();
    var root = document.querySelector('.nyum-page--the-nyum-standard .nyum-standard-action');
    if (!root || !window.MutationObserver) return;
    var observer = new MutationObserver(initNyumStandardChecks);
    observer.observe(root, { attributes: true, attributeFilter: ['data-nyum-standard-active'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
}());


/* NYUM SEARCH DRAWER — expandable Cymbiotika-style search */
(function () {
  'use strict';

  var products = [
    { title:'Organic Fucoidan™', tag:'DAILY STARTING FORMULA', url:'/products/organic-fucoidan', image:'https://cdn.shopify.com/s/files/1/0641/4558/8375/files/nyum-organic-fucoidan-hero-first_4da860e0-5f30-4f9a-97a8-e9ecada01799.png?v=1787088353' },
    { title:'Fucoidan Force®', tag:'#01 BESTSELLER', url:'/products/fucoidanforce', image:'https://cdn.shopify.com/s/files/1/0641/4558/8375/files/nyum-primary-fucoidan-force-1400x1120_b8bcaad9-5033-4b32-8529-f57e28e17ae0.png?v=1786145749' },
    { title:'Fucoidan Phoenix™', tag:'DUAL-SOURCE FORMULA', url:'/products/fucoidan-phoenix', image:'https://cdn.shopify.com/s/files/1/0641/4558/8375/files/nyum-phoenix-hero-first_e972112f-cfac-4497-a904-71af924af12b.png?v=1787088350' },
    { title:'Fenvir Advanced®', tag:'SECOND BESTSELLER', url:'/products/fenvir', image:'https://cdn.shopify.com/s/files/1/0641/4558/8375/files/nyum-primary-fenvir-1400x1120_ffe3d149-2128-4f88-acd6-a1d4a7d3d0d1.png?v=1786145741' }
  ];
  var popular = ['fucoidan','gummies','mushrooms','reishi','shilajit','fenvir'];

  function initNyumSearchDrawer() {
    var header = document.querySelector('[data-nyum-header]');
    if (!header || header.getAttribute('data-nyum-search-ready') === 'true') return;
    var trigger = header.querySelector('.nyum-rebuild-search');
    if (!trigger) return;

    var drawer = document.createElement('section');
    drawer.className = 'nyum-rebuild-search-drawer';
    drawer.setAttribute('data-nyum-search-drawer', '');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-label', 'Search Nyum');
    drawer.innerHTML =
      '<div class="nyum-rebuild-search-drawer__inner">' +
        '<div class="nyum-rebuild-search-drawer__top"><span>SEARCH NYUM</span><button type="button" class="nyum-rebuild-search-drawer__close" data-nyum-search-close aria-label="Close search"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 5 14 14M19 5 5 19"></path></svg></button></div>' +
        '<form class="nyum-rebuild-search-drawer__form" action="/search" method="get" role="search">' +
          '<span aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="m16 16 5 5"></path></svg></span>' +
          '<label><span class="visually-hidden">Search products and articles</span><input type="search" name="q" placeholder="Search products, ingredients, or guides…" autocomplete="off"></label>' +
          '<input type="hidden" name="type" value="product,article,page"><button type="submit">SEARCH →</button>' +
        '</form>' +
        '<div class="nyum-rebuild-search-drawer__content">' +
          '<aside class="nyum-rebuild-search-drawer__popular"><small>POPULAR SEARCHES</small><div class="nyum-rebuild-search-drawer__popular-list">' +
            popular.map(function (term) { return '<button type="button" data-nyum-search-term="' + term + '">' + term + '</button>'; }).join('') +
          '</div></aside>' +
          '<div><div class="nyum-rebuild-search-drawer__products-head"><small>RECOMMENDED FORMULAS</small><span>SHOP THE SYSTEM</span></div><div class="nyum-rebuild-search-drawer__products">' +
            products.map(function (product) { return '<a class="nyum-rebuild-search-drawer__product" href="' + product.url + '"><span><img src="' + product.image + '" alt="" loading="eager" width="400" height="600"></span><small>' + product.tag + '</small><b>' + product.title + '</b><em>VIEW FORMULA →</em></a>'; }).join('') +
          '</div></div>' +
        '</div>' +
      '</div>';

    var backdrop = document.createElement('div');
    backdrop.className = 'nyum-rebuild-search-backdrop';
    backdrop.setAttribute('data-nyum-search-backdrop', '');
    backdrop.setAttribute('aria-hidden', 'true');
    document.body.appendChild(backdrop);
    header.appendChild(drawer);

    var input = drawer.querySelector('input[type="search"]');
    var form = drawer.querySelector('form');

    function close() {
      header.classList.remove('is-search-open');
      document.body.classList.remove('nyum-search-drawer-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
    }
    function open() {
      header.classList.add('is-search-open');
      document.body.classList.add('nyum-search-drawer-open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      input.focus(); window.setTimeout(function () { input.focus(); }, 80);
    }

    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (header.classList.contains('is-search-open')) close(); else open();
    });
    drawer.querySelector('[data-nyum-search-close]').addEventListener('click', close);
    backdrop.addEventListener('click', close);
    drawer.querySelectorAll('[data-nyum-search-term]').forEach(function (button) {
      button.addEventListener('click', function () {
        input.value = button.getAttribute('data-nyum-search-term') || '';
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && header.classList.contains('is-search-open')) {
        close();
        trigger.focus();
      }
    });
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var query = input.value.trim();
      if (query) window.location.href = '/search?q=' + encodeURIComponent(query) + '&type=product%2Carticle%2Cpage';
    });
    header.setAttribute('data-nyum-search-ready', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNyumSearchDrawer, { once: true });
  } else {
    initNyumSearchDrawer();
  }
  document.addEventListener('shopify:section:load', initNyumSearchDrawer);
}());


/* NYUM SEARCH DRAWER — predictive product autocomplete */
(function () {
  'use strict';

  var hintGroups = [
    ['fucoidan', ['fucoidan', 'fucoidan force', 'organic fucoidan', 'fucoidan phoenix']],
    ['fenvir', ['fenvir', 'fenvir advanced', 'skin + immune']],
    ['shilajit', ['shilajit', 'shilaforce', 'shilajit resin']],
    ['gumm', ['gummies', 'ashwagandha gummies', 'mushroom gummies', 'sea moss gummies']],
    ['mushroom', ['mushrooms', 'reishi', 'mushroom complex']],
    ['reishi', ['reishi', 'organic reishi']]
  ];

  function initNyumPredictiveSearch() {
    var header = document.querySelector('[data-nyum-header]');
    var drawer = header && header.querySelector('[data-nyum-search-drawer]');
    if (!drawer || drawer.getAttribute('data-nyum-predictive-ready') === 'true') return;

    var form = drawer.querySelector('form');
    var input = drawer.querySelector('input[type="search"]');
    var staticContent = drawer.querySelector('.nyum-rebuild-search-drawer__content');
    if (!form || !input) return;

    var submit = form.querySelector('button[type="submit"]');
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'nyum-rebuild-search-drawer__clear';
    clear.setAttribute('aria-label', 'Clear search');
    clear.textContent = '×';
    if (submit) form.insertBefore(clear, submit);

    var predictive = document.createElement('div');
    predictive.className = 'nyum-rebuild-search-drawer__predictive';
    predictive.setAttribute('data-nyum-search-predictive', '');
    predictive.setAttribute('aria-live', 'polite');
    predictive.hidden = true;
    predictive.innerHTML =
      '<div class="nyum-rebuild-search-drawer__predictive-head"><small>SEARCH SUGGESTIONS</small><span data-nyum-search-count></span></div>' +
      '<div class="nyum-rebuild-search-drawer__chips" data-nyum-search-chips></div>' +
      '<div class="nyum-rebuild-search-drawer__matches-head"><small data-nyum-search-matches-label>MATCHING FORMULAS</small><span>SHOP THE SYSTEM</span></div>' +
      '<div class="nyum-rebuild-search-drawer__matches" data-nyum-search-matches></div>';
    form.insertAdjacentElement('afterend', predictive);

    var chips = predictive.querySelector('[data-nyum-search-chips]');
    var matches = predictive.querySelector('[data-nyum-search-matches]');
    var count = predictive.querySelector('[data-nyum-search-count]');
    var label = predictive.querySelector('[data-nyum-search-matches-label]');
    var fallback = Array.from(drawer.querySelectorAll('.nyum-rebuild-search-drawer__product')).map(function (card) {
      var image = card.querySelector('img');
      return {
        title: card.querySelector('b') ? card.querySelector('b').textContent.trim() : '',
        tag: card.querySelector('small') ? card.querySelector('small').textContent.trim() : 'FORMULA',
        url: card.href,
        image: image ? image.currentSrc || image.src : '',
        price: ''
      };
    });
    var requestId = 0;

    function unique(list) {
      return list.filter(function (item, index) { return item && list.indexOf(item) === index; });
    }
    function formatPrice(value) {
      var raw = String(value || '').trim();
      if (!raw) return '';
      var amount = parseFloat(raw.replace(/[^0-9.-]/g, ''));
      if (!isFinite(amount)) return raw;
      var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency,
          currencyDisplay: 'narrowSymbol',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount) + ' ' + currency;
      } catch (error) {
        return raw + ' ' + currency;
      }
    }
    function termsFor(query) {
      var q = query.toLowerCase();
      var terms = [];
      hintGroups.forEach(function (group) {
        if (q.indexOf(group[0]) !== -1 || group[0].indexOf(q) === 0) terms = terms.concat(group[1]);
      });
      fallback.forEach(function (item) {
        var title = item.title.toLowerCase();
        if (title.indexOf(q) !== -1) terms.push(item.title.replace(/\s+—.*$/, ''));
      });
      terms.unshift(query);
      return unique(terms).slice(0, 5);
    }
    function normalize(item) {
      var rawTitle = item.title || '';
      var title = rawTitle.replace(/\s+—.*$/, '').trim();
      var fallbackMatch = fallback.find(function (candidate) {
        return candidate.title.toLowerCase().indexOf(title.toLowerCase()) !== -1 ||
          title.toLowerCase().indexOf(candidate.title.toLowerCase()) !== -1 ||
          rawTitle.toLowerCase().indexOf(candidate.title.toLowerCase()) !== -1;
      });
      var image = fallbackMatch ? fallbackMatch.image : (item.image || item.featured_image || '');
      if (image && typeof image === 'object') image = image.url || image.src || '';
      return {
        title: fallbackMatch ? fallbackMatch.title : (title || rawTitle),
        tag: fallbackMatch ? fallbackMatch.tag : (item.product_type || item.type || 'FORMULA'),
        url: item.url || (fallbackMatch ? fallbackMatch.url : '#'),
        image: image || '',
        price: formatPrice(item.price)
      };
    }
    function renderCard(item) {
      var card = document.createElement('a');
      card.className = 'nyum-rebuild-search-drawer__match';
      card.href = item.url || '#';
      var visual = document.createElement('span');
      var image = document.createElement('img');
      image.src = item.image || '';
      image.alt = item.title || '';
      image.loading = 'eager';
      image.width = 400;
      image.height = 600;
      visual.appendChild(image);
      var tag = document.createElement('small');
      tag.textContent = item.tag || 'FORMULA';
      var title = document.createElement('b');
      title.textContent = item.title || 'View formula';
      var action = document.createElement('em');
      action.textContent = item.price ? item.price + ' · VIEW FORMULA →' : 'VIEW FORMULA →';
      card.appendChild(visual);
      card.appendChild(tag);
      card.appendChild(title);
      card.appendChild(action);
      return card;
    }
    function render(query, items, searching) {
      var hasQuery = query.length > 0;
      predictive.hidden = !hasQuery;
      clear.style.visibility = hasQuery ? 'visible' : 'hidden';
      if (staticContent) staticContent.hidden = hasQuery;
      if (!hasQuery) return;
      var suggestions = termsFor(query);
      chips.innerHTML = '';
      suggestions.forEach(function (term) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'nyum-rebuild-search-drawer__chip';
        chip.textContent = term;
        chip.addEventListener('click', function () {
          input.value = term;
          render(term.toLowerCase(), [], true);
          input.focus();
          lookup(term);
        });
        chips.appendChild(chip);
      });
      label.textContent = 'PRODUCTS MATCHING “' + query.toUpperCase() + '”';
      matches.innerHTML = '';
      if (!items.length) {
        var empty = document.createElement('div');
        empty.className = 'nyum-rebuild-search-drawer__no-match';
        empty.textContent = searching ? 'Finding matching formulas…' : 'No exact formula match yet. Press SEARCH to see all results.';
        matches.appendChild(empty);
        count.textContent = searching ? 'SEARCHING' : '';
        return;
      }
      count.textContent = items.length + (items.length === 1 ? ' MATCH' : ' MATCHES');
      items.slice(0, 4).forEach(function (item) { matches.appendChild(renderCard(item)); });
    }
    function localMatches(query) {
      var q = query.toLowerCase();
      return fallback.filter(function (item) {
        return (item.title + ' ' + item.tag).toLowerCase().indexOf(q) !== -1 ||
          (q.indexOf('fucoidan') !== -1 && item.title.toLowerCase().indexOf('fucoidan') !== -1) ||
          (q.indexOf('fenvir') !== -1 && item.title.toLowerCase().indexOf('fenvir') !== -1);
      });
    }
    function lookup(query) {
      var id = ++requestId;
      var local = localMatches(query);
      render(query.toLowerCase(), local, false);
      var params = new URLSearchParams();
      params.set('q', query);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '4');
      params.set('resources[options][unavailable_products]', 'last');
      fetch('/search/suggest.json?' + params.toString(), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (response) { if (!response.ok) throw new Error('predictive search unavailable'); return response.json(); })
        .then(function (data) {
          if (id !== requestId) return;
          var products = data && data.resources && data.resources.results && data.resources.results.products;
          if (Array.isArray(products) && products.length) render(query.toLowerCase(), products.map(normalize), false);
        })
        .catch(function () {});
    }
    input.addEventListener('input', function () {
      var query = input.value.trim();
      if (query.length < 2) {
        requestId++;
        render('', [], false);
        return;
      }
      lookup(query);
    });
    clear.addEventListener('click', function () {
      input.value = '';
      requestId++;
      render('', [], false);
      input.focus();
    });
    clear.style.visibility = 'hidden';
    drawer.setAttribute('data-nyum-predictive-ready', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNyumPredictiveSearch, { once: true });
  } else {
    initNyumPredictiveSearch();
  }
  document.addEventListener('shopify:section:load', initNyumPredictiveSearch);
}());
